import {
  Glass,
  ScreenLabel,
  BodyText,
  BackNav,
  Flag,
  alpha,
  borderAlpha,
} from "../../components/mobile/primitives";

/** File detail screen showing metadata and extracted biomarkers */
export function FlowFileDetail() {
  const biomarkers = [
    { name: "Hemoglobin", value: "14.2 g/dL", flag: null },
    { name: "Glucose (fasting)", value: "95 mg/dL", flag: null },
    { name: "TSH", value: "4.8 mIU/L", flag: "HIGH" },
    { name: "Vitamin D", value: "18 ng/mL", flag: "LOW" },
    { name: "LDL Cholesterol", value: "142 mg/dL", flag: "HIGH" },
  ];

  return (
    <div style={{ padding: "0 16px", display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Back header */}
      <div style={{ display: "flex", alignItems: "center", padding: "0" }}>
        <BackNav label="Back" />
        <div style={{ flex: 1 }} />
        <BodyText size={10} color="var(--color-kin-muted)" weight={500}>
          File Detail
        </BodyText>
        <div style={{ flex: 1 }} />
        <div style={{ width: 30 }} />
      </div>

      {/* Title + status */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
        <div style={{ flex: 1 }}>
          <BodyText size={12} weight={700}>
            Blood Panel Feb 2026
          </BodyText>
        </div>
        <div
          style={{
            padding: "2px 8px",
            borderRadius: 10,
            background: alpha("var(--color-kin-green-soft)", "18"),
            border: borderAlpha("var(--color-kin-green-soft)", "40"),
          }}
        >
          <BodyText size={8} color="var(--color-kin-green-soft)" weight={700}>
            Ready
          </BodyText>
        </div>
      </div>

      {/* Summary */}
      <BodyText size={9.5} color="var(--color-kin-muted)" weight={400} style={{ lineHeight: 1.45 }}>
        Complete metabolic panel with 23 markers extracted. 2 values flagged outside reference
        range.
      </BodyText>

      {/* Metadata card */}
      <Glass style={{ borderRadius: 18 }}>
        <div style={{ padding: "0 14px" }}>
          {[
            ["Type", "application/pdf"],
            ["Category", "Lab Results"],
            ["Size", "1.2 MB"],
            ["Added", "March 18, 2026"],
          ].map(([label, value], i) => (
            <div
              key={label}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 0",
                borderBottom: i < 3 ? "1px solid rgba(0,0,0,0.05)" : "none",
              }}
            >
              <BodyText size={9} color="var(--color-kin-muted)" weight={500}>
                {label}
              </BodyText>
              <BodyText size={10} weight={500}>
                {value}
              </BodyText>
            </div>
          ))}
        </div>
      </Glass>

      {/* Extracted Biomarkers */}
      <Glass style={{ borderRadius: 18 }}>
        <div style={{ padding: "14px" }}>
          <BodyText size={10.5} weight={700} style={{ marginBottom: 4 }}>
            Extracted Biomarkers
          </BodyText>
          <BodyText
            size={8.5}
            color="var(--color-kin-muted)"
            weight={400}
            style={{ marginBottom: 10 }}
          >
            {biomarkers.length} values from this file
          </BodyText>

          {/* Table header */}
          <div
            style={{
              display: "flex",
              padding: "6px 0",
              borderBottom: "1px solid rgba(0,0,0,0.06)",
            }}
          >
            <ScreenLabel style={{ flex: 3 }}>Marker</ScreenLabel>
            <ScreenLabel style={{ flex: 2 }}>Value</ScreenLabel>
            <ScreenLabel style={{ width: 24, textAlign: "center" }}></ScreenLabel>
          </div>

          {/* Rows */}
          {biomarkers.map((bm, i) => (
            <div
              key={bm.name}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 0",
                borderBottom: i < biomarkers.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
              }}
            >
              <BodyText size={10} weight={500} style={{ flex: 3 }}>
                {bm.name}
              </BodyText>
              <BodyText size={10} color="var(--color-kin-muted)" weight={400} style={{ flex: 2 }}>
                {bm.value}
              </BodyText>
              <div style={{ width: 24, display: "flex", justifyContent: "center" }}>
                <Flag type={bm.flag} />
              </div>
            </div>
          ))}
        </div>
      </Glass>

      {/* Action buttons */}
      <div style={{ display: "flex", gap: 10 }}>
        <div
          style={{
            flex: 1,
            background: "var(--color-kin-green-soft)",
            borderRadius: 14,
            padding: "11px 0",
            textAlign: "center",
            boxShadow: "0 2px 8px -2px rgba(91,122,102,0.3)",
          }}
        >
          <BodyText size={10} color="#fff" weight={700}>
            Preview
          </BodyText>
        </div>
        <div
          style={{
            flex: 1,
            background: "rgba(255,107,107,0.10)",
            border: "1px solid rgba(255,107,107,0.18)",
            borderRadius: 14,
            padding: "11px 0",
            textAlign: "center",
          }}
        >
          <BodyText size={10} color="var(--color-kin-rose)" weight={700}>
            Delete
          </BodyText>
        </div>
      </div>
    </div>
  );
}
